module.exports = __webpack_public_path__ + "img/part-four-thumb.5a63922.jpg";